import { CursorPaginatedApiResponse } from '../../../types/responses/cursor-paginated.response';
import { client } from './client';
import { PlotStyleApiModel } from '../../../types/models/plot-style.model';
import { SearchPlotStylesApiRequest } from '../../../types/requests/plot-styles/search-plot-styles.request';

export const searchPlotStyles = <T extends PlotStyleApiModel>(params: SearchPlotStylesApiRequest) =>
  client.get<CursorPaginatedApiResponse<T>>(`/plot-styles`, { params });
